function resolveToPixels(cssValue) {

  if (cssValue.endsWith('px')) {
    return parseFloat(cssValue);
  }

  if (cssValue.endsWith('vh')) {
    return parseFloat(cssValue) * window.innerHeight / 100;
  }

  if (cssValue.endsWith('vw')) {
    return parseFloat(cssValue) * window.innerWidth / 100;
  }

  if (cssValue.endsWith('rem')) {
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return parseFloat(cssValue) * rootFontSize;
  }

  return parseFloat(cssValue);

}

export { resolveToPixels };
